import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Inspection } from '../../class/inspection';

@Injectable()
export class InspectionService extends WebService {

    public getInspection (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('inspection_equipment,inspection_has_equipment,station,maintenance_assistant,service_manager'));

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/inspections?${params}`, options);
    }

    public newInspection(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/inspections`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateInspection(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/inspections/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteInspection(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/inspections/${id}`, { headers: this.headers } );
    }

    public infoInspection(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        params.append('_with', String('inspection_equipment,inspection_has_equipment,station,maintenance_assistant,service_manager'));
        const options = new RequestOptions({search: params, headers: this.headers});
        return this.http.get( `${this.apiUrl}/inspections?${params}`, options);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/inspection/inspection.service.ts